import type { Jet } from '~/jet';
import {
    CommerceModalActionOperationType,
    makeCommerceModalAction,
} from '~/actions/commerce-modal-action';
import type { LoggerFactory } from '@amp/web-apps-logger';
// Safe because this file is only imported from ./browser.ts
import type { Commerce } from '~/utils/commerce/browser-only';
import type { Playback } from '~/utils/playback/browser-only';
import { CommerceRoute } from '~/utils/commerce/models';
// import type { LocalLibraryState } from '~/utils/local-library-state';
// import { isLibrarySearch } from '~/stores/is-library-search';
// import { makeInvalidationAction } from '~/jet/web-actions/invalidation-actions';
import type { SignOutAction } from '~/actions/sign-out-action';
// import { shouldRedirectOnSignout } from '@amp/web-app-components/src/utils/should-redirect-on-signout';
// import { makeNavigationAction } from '~/constants/navigation-items';
// import { listenNowPageIntent } from '~/jet/intents';
// import { HOME_ID } from '~/constants/tabs';
import { fullScreenPlayerState } from '~/stores/full-screen-player';

export type Dependencies = {
    jet: Jet;
    logger: LoggerFactory;
    playback: Playback;
    commerce: Commerce;
    // localLibraryState: LocalLibraryState;
};

export function registerHandler(dependencies: Dependencies) {
    const { jet, logger, playback, commerce /*localLibraryState*/ } =
        dependencies; // TODO: musickit as a dependency, need router or current route here

    const log = logger.loggerFor('jet/action-handlers/sign-out-action');

    jet.onAction('signOutAction', async (action: SignOutAction) => {
        log.info('received SignOut:', action);
        try {
            // The Commerce logout action must fire before `playback.unauthorize()`.
            //
            // In some scenarios, unauthorizing playback triggers an event `eligibleForSubscribeView`
            // which we handle by triggering a subscribe commerce modal.
            // https://github.pie.apple.com/amp-web/media-apps/blob/ece021333b0a8fe03f70f2ba138a0ddde956c925/apps/music/src/utils/commerce/browser-only.ts#L343-L357
            //
            // We wait for the Commerce logout action to finish before any other Commerce modals get triggered in order to prevent logout errors.
            await jet.perform(
                makeCommerceModalAction({
                    type: CommerceModalActionOperationType.Open,
                    activePath: CommerceRoute.logout,
                }),
            );
            await playback.unauthorize();
            commerce.state.resetUser();
            fullScreenPlayerState.reset();
            // localLibraryState.clear();
            // isLibrarySearch.set(false);
            // jet.updateUserInfo(null);
            // jet.perform(
            //     makeInvalidationAction({ kind: 'subscriptionStatusChange' }),
            // );
            // TODO: Pass in SSR Location to below method when ServerKit is Integrated
            // if (shouldRedirectOnSignout()) {
            //     jet.perform(
            //         makeNavigationAction(
            //             listenNowPageIntent({
            //                 storefront: null,
            //                 language: null,
            //             }),
            //             HOME_ID.type,
            //             '/home',
            //         ),
            //     );
            // }

            // TODO: rdar://88197677 Delete Metrics ConsumerId (metrics.baseData.consumerId) on Sign Out
            return 'performed';
        } catch (e) {
            log.error('Sign Out Action Error:', e);
            throw new Error('an error occurred while handling Sign Out');
        }
    });
}
